/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoUserRoleCreate } from '../../models/dto-user-role-create';
import { UserRoleItem } from '../../models/user-role-item';

export interface UserRoleControllerCreate$Params {
      body: DtoUserRoleCreate
}

export function userRoleControllerCreate(http: HttpClient, rootUrl: string, params: UserRoleControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
  const rb = new RequestBuilder(rootUrl, userRoleControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserRoleItem;
      }>;
    })
  );
}

userRoleControllerCreate.PATH = '/user-role';
